import React, { useEffect, useState } from 'react';
import { Clock, Sparkles, ShieldCheck, Zap } from 'lucide-react';
const items = [{
  icon: Sparkles,
  text: 'OFERTA DE LANZAMIENTO: 75% OFF + 5 Bonus Exclusivos (Solo por tiempo limitado)'
}, {
  icon: Zap,
  text: 'Acceso inmediato después del pago'
}, {
  icon: ShieldCheck,
  text: 'Un solo pago · Sin suscripciones · Acceso de por vida'
}, {
  icon: Sparkles,
  text: 'Herramienta lista para usar en Google Sheets'
}];
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const countdown = `${String(timeLeft.hours).padStart(2, '0')}:${String(timeLeft.minutes).padStart(2, '0')}:${String(timeLeft.seconds).padStart(2, '0')}`;
  const sequence = <div className="flex items-center shrink-0" aria-hidden="true" data-id="element-192" data-mp="2qcsw0pfyq9ul">
      {items.map((item, index) => <span key={index} className="flex items-center" data-id="element-193" data-mp="2lfamoxy19sm2" data-mpi={index}>
          <span className="flex items-center gap-2 px-5 md:px-7" data-id="element-194" data-mp="2gemrs16oormk">
            <item.icon className="w-3.5 h-3.5 md:w-4 md:h-4 text-stone-800 flex-shrink-0" data-id="element-195" data-mp="2cdt67egprowu" />
            <span className="whitespace-nowrap text-xs md:text-sm font-bold" data-id="element-196" data-mp="2cg5oxtuaq3ay">
              {item.text}
            </span>
          </span>
          <span className="w-1 h-1 rounded-full bg-stone-900/40" data-id="element-197" data-mp="10ye7o68uwozm" />
        </span>)}
      <span className="flex items-center gap-2 px-5 md:px-7" data-id="element-198" data-mp="12f9udr03g29f">
        <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 text-stone-800 flex-shrink-0" data-id="element-199" data-mp="12dyu415uxcn2" />
        <span className="whitespace-nowrap text-xs md:text-sm font-bold" data-id="element-200" data-mp="17e4mxknv556q">
          Termina en{' '}
          <span className="font-mono font-extrabold tabular-nums" data-id="element-201" data-mp="sjq35hwh5rr0">
            {countdown}
          </span>
        </span>
      </span>
      <span className="w-1 h-1 rounded-full bg-stone-900/40" data-id="element-202" data-mp="jplft8gjuyg8" />
    </div>;
  return <div className="bg-amber-400 text-stone-900 py-2 relative z-50 overflow-hidden" data-id="element-203" data-mp="og1tmtoa8m34">
      {/* Static summary for screen readers */}
      <p className="sr-only" data-id="element-204" data-mp="9rxcvv8sikmz">
        Oferta de lanzamiento: 75% de descuento más 5 bonus exclusivos, solo por
        tiempo limitado, con un solo pago y acceso de por vida.
      </p>
      <div className="marquee-track" data-id="element-205" data-mp="pxt4v6e52gc">
        {sequence}
        {sequence}
      </div>
    </div>;
}